import { render } from "./new-payable-account.vue?vue&type=template&id=44a07652"
import script from "./new-payable-account.vue?vue&type=script&lang=js"
export * from "./new-payable-account.vue?vue&type=script&lang=js"

import "./new-payable-account.vue?vue&type=style&index=0&id=44a07652&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__